module.exports = __webpack_public_path__ + "img/ic_custom_field.b83e07dc.svg";